import React, {memo} from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

/* Cosmos */
import HModal from '@cosmos/hmodal'
import Button from '@cosmos/button'

/* Config */
import appConfig, {sfBaseUrl} from '../../appConfig'

/* Utils */
import {setBrowserCookie} from '../../../client/common/persistence/browserCookieUtils'

/* Actions */
import {actionCreators as productActionsCreators} from '../../redux/actions/productActions'

/* Styles */
import s from './AdultModal.scss'

const AdultModal = memo((props) => {
  const {
    dispatch,
    className,
    shouldCloseOnOverlayClick,
    viewType,
    platform
  } = props;

  const rootClassName = cx(s.root, className);

  const handleModalClose = () => {
    window.location.href = `${sfBaseUrl}`;
  }

  const handleOver18 = () => {
    setBrowserCookie('hb_adult', '1');
    dispatch(
      productActionsCreators.setAdultProduct.trigger(false),
    )
  }

  const handleUnder18 = () => {
    setBrowserCookie('hb_adult', '0');
    dispatch(
      productActionsCreators.setAdultProduct.trigger(true),
    )
    window.location.href = `${sfBaseUrl}`;
  }

  const renderContent = () => {
    return (
      <div className={cx(s.adultContent, s[platform])}>
        <div className={s.icon} data-test-id='18product-icon'>
          {'18 +'}
        </div>
        <div className={s.text} data-test-id='18product-title'>
          {'Bu ürünü görebilmek ve satın alabilmek için 18 yaşından büyük olman gerekiyor'}
        </div>
        <div className={s.info} data-test-id='18product-desc'>
          {'Türk Ceza Kanunu’nun 226. Maddesi gereğince 18 yaşın altındaki kullanıcıların bu sayfayı görüntülemesi ve ürün satın alması yasastır.'}
        </div>
        <div className={s.buttonContainer}>
          <Button
            prefix={appConfig.cosmosPrefix}
            data-test-id={'plus18-button'}
            onClick={handleOver18}>
            {'18 yaşından büyüğüm'}
          </Button>
          <Button
            prefix={appConfig.cosmosPrefix}
            data-test-id={'minus18-button'}
            onClick={handleUnder18}>
            {'18 yaşından küçüğüm'}
          </Button>
        </div>
      </div>
    )
  }

  return (
    <HModal
      appElementId={'root'}
      className={rootClassName}
      portalClassName={'product18-Modal'}
      contentClassName={s.content}
      isOpen
      scrollLock
      closeButtonEnabled={false}
      viewType={viewType}
      size={'HB_MODAL_SIZE'}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      onClose={handleModalClose}>
      {renderContent()}
    </HModal>
  )
});

AdultModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  viewType: PropTypes.string,
  platform: PropTypes.string,
  className: PropTypes.string,
  shouldCloseOnOverlayClick: PropTypes.func
}

AdultModal.defaultProps = {
  viewType: 'SHEET'
}

export default AdultModal;
